//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { UnmoderatedContentModalActionType } from '@galleries/actions/unmoderatedContentModalActions';
import { UNMODERATED_CONTENT_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IUnmoderatedContentModal } from '@galleries/models/galleriesStateModel';

const initialState: IUnmoderatedContentModal = {
  isOpen: false,
};

export default function UnmoderatedContentModalReducer(
  state: IUnmoderatedContentModal = initialState,
  action: UnmoderatedContentModalActionType,
): IUnmoderatedContentModal {
  switch (action.type) {
    case UNMODERATED_CONTENT_MODAL_ACTIONS.OPEN_UNMODERATED_CONTENT_MODAL: {
      return {
        ...state,
        isOpen: true,
      };
    }
    case UNMODERATED_CONTENT_MODAL_ACTIONS.CLOSE_UNMODERATED_CONTENT_MODAL: {
      return {
        ...state,
        isOpen: false,
      };
    }
    default:
      return state;
  }
}
